<template>
  <v-container>
    <v-layout row>
      <v-flex class="row top" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row class="containerBanner">
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md9 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h3 class="pull">Equipo estratégico de {{this.ccComplete.ccNombre}}</h3>
            </v-flex>
          </v-layout>

          <v-flex v-if="vacio" class="containerBanner" md12 lg12 xs12 sm12>
            <img :src="nube" style="width:25%;" />
          </v-flex>
          <v-flex v-if="vacio" md12 lg12 xs12 sm12>
            <h4>No hemos encontrado ningún integrante en tu grupo de trabajo</h4>
            <h4>Ingresa un integrante</h4>
          </v-flex>

          <v-layout v-if="!vacio">
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th
                      style="text-align: left"
                      :class="header.size"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in personas" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.nombre}}</td>
                    <td style="text-align:left " :class="headers[1].size">{{item.correo}}</td>
                    <td style="text-align:left " :class="headers[2].size">{{item.cargo}}</td>
                    <td :class="headers[3].size">
                      <v-icon small class="mr-2" @click="openEditPersona(item,index)">edit</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>

          <v-layout justify-start row fill-height class="margin-button">
            <v-flex md12 lg12 xs8 sm8>
              <v-btn color="#394049" small @click="opencreatePersona">Agregar Personal</v-btn>
            </v-flex>

            <v-flex md2 lg2 xs2 sm2>
              <img :src="img3" class="image" @click="asistencia = true" />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

      <v-flex md1.5 lg1.5 xs0 sm0 hidden-sm-and-down>
        <v-layout>
          <v-dialog v-model="asistencia" width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card>
              <v-card-title>
                <span class="headline">Asistencia Dge</span>
              </v-card-title>
              <div class="form-group">
                <label for="comment">Comenta tus inquietudes</label>
                <textarea class="form-control" rows="9" id="comment"></textarea>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#ec6a12" flat="flat" @click="asistencia = false">Cerrar</v-btn>
                <v-btn color="#394049" flat="flat" @click="sendDge">Enviar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm11 hidden-md-and-up></v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="edit" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline" v-if="!create">Editar Personal</span>
            <span class="headline" v-if="create">Crear Personal</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex  md12 lg12 xs12 sm12>
                <label class="left" for="usr">Nombre</label>
                <input v-model="persona.nombre" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label class="left" for="usr">Correo</label>
                <input v-model="persona.correo" type="email" class="form-control" id="usr" />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label class="left" for="sel1">Estamento</label>
                <select
                  class="form-control"
                  id="1"
                 v-model="persona.cargo"
                >
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Académico">Académico</option>
                  <option value="Profesor por hora">Profesor por hora</option>
                  <option value="Empleador">Empleador</option>
                  <option value="Funcionario">Funcionario</option>
                  <option value="Estudiante">Estudiante</option>
                  <option value="Otro">Otro</option>
                </select>
               
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="validatePersona(2)">Editar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="validatePersona(1)">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import img3 from "../../assets/nuevaasistencia.png";
import nube from "../../assets/nube.png";
import personas from "../util/equipos.json";
import img1 from "../../assets/Captura.png";

import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      img1: img1,
      vacio: "",
      ccComplete: "",
      nube: nube,
      step1: true,
      evaluaciones: personas,
      personas: "",
      img3: img3,
      asistencia: false,

      create: false,
      edit: false,
      index: "",
      dialog: false,
      persona: {
        nombre: "",
        correo: "",
        cargo: ""
      },

      headers: [
        {
          text: "Nombre",
          value: "name",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4"
        },

        {
          text: "Correo",
          value: "muy desacuerdo",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4"
        },
        {
          text: "Estamento",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },
        {
          text: "Editar",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],

      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      img1: img1,

      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    vacio: function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },

  created() {
    this.ccComplete = this.$session.getAll().ccData;
    //console.log(this.ccComplete);
  },

  mounted() {
    this.initComponent();
  },

  validations: {
    persona: {
      nombre: {
        required
      },
      correo: {
        required
      },
      cargo: {
        required
      }
    }
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },
    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },

    initComponent() {
      axios
        .get(
          process.env.ROOT_API +
            "/equipo/getByCc?cc=" +
            this.ccComplete.ccValor,
          this.auth
        )
        .then(response => {
          this.personas = response.data.personas;
          if (this.personas.length == 0) {
            this.vacio = true;
          } else {
            this.vacio = false;
          }
          //console.log(this.personas);
        })
        .catch(error => console.error(error));
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    validatePersona(index) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (index == 1) {
          this.createPersona();
        } else {
          this.editPersona();
        }
      } else {
        alert("Faltan datos por registrar");
      }
    },

    openEditPersona(persona, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.persona = persona;
    },

    editPersona() {
      axios
        .post(
          process.env.ROOT_API +
            "/equipo/editPersonal?cc=" +
            this.ccComplete.ccValor,
          this.personas,
          this.auth
        )
        .then(response => {
          alert("Personal Editado");
          this.vacio = false;
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
      this.edit = false;
    },

    opencreatePersona() {
      this.create = true;
      this.edit = true;
      this.persona = {
        nombre: "",
        correo: "",
        cargo: ""
      };
    },

    createPersona() {
      axios
        .post(
          process.env.ROOT_API +
            "/equipo/addPersona?cc=" +
            this.ccComplete.ccValor,
          this.persona,
          this.auth
        )
        .then(response => {
          alert("Personal Añadido");
          this.vacio = false;
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });

      this.personas.push(this.persona);
      this.edit = false;
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },

    cambio1() {
      this.step1 = true;
    },
    cambio2() {
      this.step1 = false;
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 145px !important;
}

.v-card-new {
  margin-bottom: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 120px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}
.text-vision {
  color: white;
  font-size: 12px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 360px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}

.th {
  background-color: aqua !important;
}

.margin-button {
  margin-bottom: 50px !important;
}

.top {
  margin-top: 50px !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>


// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/EquipoEstrategico.vue